import { Chip, Divider, Typography, Box } from "@mui/material";
import React from "react";
import { formatNumber } from "../../../function/FormatNumber";
import ModalPdfProfile from "./modals/ModalPdfProfile";
import ModalSwicthPosition from "./modals/ModalSwicthPosition";


function ProfileOverview(props) {
	const { dataCandidateByID, handleCloseModalCandidate, fetchCandidateOpportunityByID } = props;
	// const createPdfHtml = () => {
	// 	const stringHtml = renderToString(<Prints />);
	// 	const pdf = new jsPDF('p', 'mm', 'a4');;
	// 	pdf.html(stringHtml, {
	// 		callback: function (pdf) {
	// 			pdf.save('profile.pdf');
	// 		},
	// 	});
	// }

	// const createProfilePdf = () => {
	// 	const input = document.getElementById('divToPrint');
	// 	html2canvas(input,)
	// 		.then((canvas) => {
	// 			let imgWidth = 208;
	// 			let imgHeight = canvas.height * imgWidth / canvas.width;
	// 			const imgData = canvas.toDataURL('img/png');
	// 			const pdf = new jsPDF('p', 'mm', 'a4');
	// 			pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
	// 			pdf.save("profile.pdf");
	// 		})
	// }

	return (
		<React.Fragment>
			<div className="form-row">
				<div className="col-md-12" style={{ display: "flex", justifyContent: "flex-end" }}>

					<ModalSwicthPosition dataCandidateByID={dataCandidateByID}
						fetchCandidateOpportunityByID={fetchCandidateOpportunityByID}
						handleCloseModalCandidate={handleCloseModalCandidate} />

					<ModalPdfProfile dataCandidateByID={dataCandidateByID} />
				</div>
			</div>
			<Box sx={{ flexGrow: 1, mt: 2 }}>
				<div className="form-row mt-2">
					<div className="col-md-4">
						<Typography color="primary" variant="h6">
							Place, Date of Birth
						</Typography>
						<Typography variant="subtitle1" style={{ color: "#595959" }}>
							{dataCandidateByID?.birth_location}, {dataCandidateByID?.birth_date?.split(",")[0].toUpperCase()}
						</Typography>
					</div>
					
					<div className="col-md-4">
						<Typography color="primary" variant="h6">
							Gender
						</Typography>
						<Typography variant="subtitle1" style={{ color: "#595959" }}>
							{dataCandidateByID?.gender === "M"
								? "Male"
								: dataCandidateByID?.gender === "F"
									? "Female"
									: "Other"}
						</Typography>
					</div>
					<div className="col-md-4">
						<Typography color="primary" variant="h6">
							Address
						</Typography>
						<Typography
							variant="subtitle1"
							style={{ color: "#595959", fontSize: 11 }}
						>
							{dataCandidateByID.address}
						</Typography>
					</div>
				</div>
				<div className="form-row mt-2">
					<div className="col-md-4">
						<Typography color="primary" variant="h6">
							Experience
						</Typography>
						{dataCandidateByID?.Experiences
							? dataCandidateByID.Experiences?.map((experience) => (
								<div key={experience.id} className="mb-1">
									<Typography sx={{ fontSize: 12, fontWeight: 600 }}>
										{experience?.job_position} - {experience?.company}
									</Typography>
									<Typography variant="subtitle2"></Typography>
									<Typography variant="subtitle2" color="GrayText">
										({experience.start_date?.split(",")[0]} -{" "}
										{experience.is_current === false
											? experience.end_date?.split(",")[0]
											: "Now"}
										)
									</Typography>
								</div>
							))
							: "-"}
					</div>
					<div className="col-md-4">
						<Typography color="primary" variant="h6">
							Education
						</Typography>
						{dataCandidateByID.Educations?.map((education) => (
							<div key={education.id} className="mb-1">
								<Typography sx={{ fontSize: 12, fontWeight: 600 }}>
									{education.degree ? education.degree : "-"} of{" "}
									{education.major}
								</Typography>
								<Typography
									variant="subtitle2"
									sx={{ fontSize: 12 }}
									color="GrayText"
								>
									{education.school_name}{" "}
									<p>IPK : {education.ipk || "-"}</p>
									{education.is_current === false ? (
										<div style={{ display: "flex" }}>
											<p>Start Year : {education.start_year}</p>&nbsp; -&nbsp;
											<p>Graduated : {education.graduate_year}</p>
										</div>
									) : (
										<p>Not Graduated</p>
									)}
								</Typography>
							</div>
						))}
					</div>
					<div className="col-md-4">
						<Typography color="primary" variant="h6">
							Course
						</Typography>
						{dataCandidateByID?.Courses
							? dataCandidateByID.Courses?.map((course) => (
								<div key={course.id} className="mb-1">
									<Typography
										variant="h6"
										sx={{ fontSize: 12, fontWeight: 600 }}
									>
										{course.course_category} at {course.course_organizer}
									</Typography>
									<Typography color="GrayText" variant="subtitle2">
										Course Year : {course.course_year}
									</Typography>
								</div>
							))
							: "-"}
					</div>
				</div>
			</Box>
			<Box sx={{ flexGrow: 1, mt: 4 }}>
				<div className="form-row mt-2">
					<div className="col-md-6">
						<Typography color="primary" variant="h6" sx={{ mb: 1 }}>
							Skills
						</Typography>
						{dataCandidateByID?.skills
							? dataCandidateByID.skills?.map((skill, index) => (
								<Chip
									key={index}
									sx={{ mr: 1, mb: 1 }}
									label={skill}
									color="success"
									variant="outlined"
								/>
							))
							: "-"}
					</div>
				</div>
			</Box>
			<Divider sx={{ mt: 2 }} />
			<Box sx={{ flexGrow: 1, mt: 4 }}>
				<div className="form-row mt-2">
					<div className="col-md-4">
						<Typography color="primary" variant="h6">
							Salary Info
						</Typography>
						<Typography variant="subtitle2" color="GrayText">
							Current Salary :{" "}
							{dataCandidateByID?.curr_salary ? (
								<p>Rp. {formatNumber(dataCandidateByID?.curr_salary)}</p>
							) : (
								"-"
							)}{" "}
							<br />
							Expected Salary :{" "}
							{dataCandidateByID?.expected_salary ? (
								<p>Rp. {formatNumber(dataCandidateByID?.expected_salary)}</p>
							) : (
								"-"
							)}
						</Typography>
					</div>
					<div className="col-md-4">
						<Typography color="primary" variant="h6">
							Benefit Info
						</Typography>
						<Typography variant="subtitle2" color="GrayText">
							Current Benefits :
							{dataCandidateByID?.curr_benefits
								? dataCandidateByID?.curr_benefits.map((benefit, index) => (
									<li key={index}>{benefit}</li>
								))
								: "-"}
							<br />
							Expected Benefits :
							{dataCandidateByID?.expected_benefits
								? dataCandidateByID?.expected_benefits.map((benefit, index) => (
									<li key={index}>{benefit}</li>
								))
								: "-"}
						</Typography>
					</div>
					<div className="col-md-4">
						<Typography color="primary" variant="h6">
							Source Information
						</Typography>
						<Typography variant="subtitle2" color="GrayText">
							Source :
							{dataCandidateByID?.source_info 
								? dataCandidateByID?.source_info 
								: "-"}
						</Typography>
					</div>
				</div>
			</Box>
			<br />
		</React.Fragment>
	);
}

export default ProfileOverview;
